import { z } from "zod";
/**
 * FE-18 — l'aperçu de lien, contrat partagé.
 *
 * Le VOLET SERVEUR part seul et en premier (`CLAUDE.md`, contrat client figé) :
 * ces schémas décrivent donc une ressource que l'app ne consomme pas encore.
 * C'est l'ordre normal ici — un binaire publié ne se met pas à jour, alors le
 * serveur est TOUJOURS celui qui attend l'autre.
 *
 * Ressource FINE, et volontairement pauvre : trois champs qui suffisent à la
 * carte (titre + domaine), pas un agrégat. Le jour où la vignette arrive, elle
 * s'ajoute — jamais elle ne remplace.
 */
/** Au-delà, ce n'est plus un lien qu'on partage : on refuse sans aller voir. */
export const LINK_PREVIEW_URL_MAX = 2048;
/** Un titre plus long ne tient pas dans la carte — coupé côté serveur, une fois. */
export const LINK_PREVIEW_TITLE_MAX = 140;
export const LinkPreviewSchema = z.object({
    /**
     * L'URL FINALE, redirections suivies : c'est elle que le domaine décrit, et
     * afficher le domaine de départ au-dessus du contenu d'un autre site serait
     * exactement le mensonge que la carte est censée empêcher.
     */
    url: z.string(),
    /** Hôte affichable, `www.` retiré — le seul rempart contre un titre menteur. */
    domain: z.string(),
    /** Jamais vide : sans titre il n'y a pas d'aperçu du tout (fail-soft). */
    title: z.string().min(1).max(LINK_PREVIEW_TITLE_MAX),
});
/**
 * Réponse ENVELOPPÉE, et `null` est une réponse à part entière : « joignable,
 * rien d'exploitable ». Le client en fait la même chose que d'une erreur — pas
 * de carte — mais le serveur, lui, a le droit de la mettre en cache.
 */
export const LinkPreviewResponseSchema = z.object({
    preview: LinkPreviewSchema.nullable(),
});
//# sourceMappingURL=links.js.map